import { useTextEditState } from '../states/text-edit-state';
import { RangeHelper } from '../utils';

export const useSelectEvent = () => {
    const disableSelectEvent = useTextEditState()((state) => state.disableSelectEvent);
    const setEditingRange = useTextEditState()((state) => state.setEditingRange);

    const handleSelect = (event: React.SyntheticEvent<HTMLDivElement>) => {
        if (disableSelectEvent) return;

        const target = event.target as HTMLDivElement;
        const editingRange = RangeHelper.getEditingRange(target);
        const isSelectAll = (() => {
            if (!editingRange) return false;
            return editingRange.startIndex === 0 && editingRange.startOffset === 0 && editingRange.isEnd;
        })();

        // ATTENTION: 由于文本编辑的兼容性问题较多，这段 log 暂时不要删除
        if (process.env.REACT_APP_ENV !== 'release') {
            console.log('TextEditPlugin - handleSelect', editingRange, isSelectAll);
        }

        setEditingRange(isSelectAll ? null : editingRange); // 全选等于没选
    };

    return {
        handleSelect,
    };
};
